import { Head } from "@inertiajs/react"
import ProductionHeader from "@/components/admin/production/ProductionHeader"
import AssetForm from "@/components/admin/production/AssetForm"
import type { SharedProductionProps } from "@/components/admin/production/types"

interface NewProps extends SharedProductionProps {
  initial?: Record<string, unknown>
  errors?: Record<string, string[]>
}

export default function AssetNew({ store, paths, initial, errors }: NewProps) {
  return (
    <>
      <Head title="Nouvel équipement" />
      <ProductionHeader
        title="Nouvel équipement"
        storeName={store.name ?? undefined}
        paths={paths}
      />
      <main className="mx-auto max-w-4xl px-6 py-8">
        <AssetForm
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          initial={initial as any}
          submitUrl={paths.assets_index}
          method="post"
          errors={errors}
          cancelUrl={paths.assets_index}
        />
      </main>
    </>
  )
}
